<template lang="pug">
	.web-services-list
		ListView.full-width(ref="listView", initialView="table", :remoteGrouping="false", :remoteSorting="false", :remoteFiltering="false", :headerFilter="true", :hideViewsSelection="true", :getTotal="(d) => d.TotalNumberOfRecords", 	
			:getItems="(d) => d.Results", :getData="loadData", :columns="columns", :pageSize="200", :searchVisible="true", :columnHidingEnabled="false")
			template(v-slot:listing-cell-template="{ data }")
				a(@click="editItem(data)")
					i.fas.fa-pen-square
			template(v-slot:name-cell-template="{ data }")
				a(@click="editItem(data)") {{data.Name}}
			template(v-slot:url-cell-template="{ data }")
				.url-holder.full-width(:title="data.Url")
					.url.text-overflow {{data.Url}}
			.flex-row.space.align-center(slot="left-actions")
				.font-big {{$tCaption('External data services')}}
				DxButton(icon="plus", type="default", @click="addNewRow")
</template>

<script>
import Data from 'app-core/Data';
import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import { EXTERNAL_SERVICES_CATEGORIES, SERVICE_STATUSES } from 'app-core/constants';

export default {
	translationCategory: 'webServiceCaller.List',
	components: { ListView, DxButton },
	data() {
		const categories = EXTERNAL_SERVICES_CATEGORIES.toLocale('name', this);
		const statuses = SERVICE_STATUSES.toLocale('name', this);
		return {
			columns: [
				{ dataField: 'CategoryName', caption: () => this.$tCaption('Category'), groupIndex: 1 },
				{ dataField: 'Name', caption: () => this.$tCaption('Name'), cellTemplate: 'name-cell-template', width: 250 },
				{ dataField: 'LifeStatus', caption: () => this.$tCaption('Life status'), 
					lookup: { 
						dataSource: () => statuses, displayExpr: 'name', valueExpr: 'id' 
					},
					width: 250
				},
				{ dataField: 'Url', caption: () => this.$tCaption('Url'), cellTemplate: 'url-cell-template' },
				{ dataField: 'Name1', caption: ' ', cellTemplate: 'listing-cell-template', width: 50  },
			],
			categories,
			statuses,
		};
	},
	methods: {
		loadData(pageIndex, size, opts) {
			return Data.getOwnExternalServices(pageIndex, size, opts).then(r => {
				r.Results = r.Results.map(f => ({
					...f,
					Url: f?.JsonDefinition?.Url,
					CategoryName: f?.ServiceCategory?.Name || this.$tCaption('Other')
				}));
				
				if (__DEBUG__)
					console.debug('Web services loaded', { r });

				return r;
			});
		},
		addNewRow(){
			this.$router.push({
				path: '/wbs/Builder/new'
			});
		},
		editItem(data) {
			if (__DEBUG__)
				console.debug('Edit item', data);
			this.$router.push({
				path: `/wbs/Builder/${data.Oid}`
			});
		}
	}
};
</script>
<style lang="scss">
	.content {
		> .web-services-list {
			padding: 20px 0px;
		}
	}

	.web-services-list {
		.url-holder {
			position: relative;
			height: 20px;
			.url {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100%;
				height: 100%;
			}
		}
	}
</style>
